/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { __extends, __values } from "tslib";
import { AnnotationLayer } from "./AnnotationLayer";
import { Series } from "./Series";
import { DependencyProperty } from "igniteui-react-core";
import { CategoryItemHighlightType_$type } from "./CategoryItemHighlightType";
import { MarkerType_$type } from "./MarkerType";
import { Brush } from "igniteui-react-core";
import { DataTemplate } from "igniteui-react-core";
import { CategoryItemHighlightLayerFrame } from "./CategoryItemHighlightLayerFrame";
import { Base, enumGetBox, fromEnum, typeCast, Point_$type, markType, markDep, runOn } from "igniteui-react-core";
import { Dictionary$2 } from "igniteui-react-core";
import { ItemHighlightFrameRect } from "./ItemHighlightFrameRect";
import { List$1 } from "igniteui-react-core";
import { IHasCategoryModePreference_$type } from "./IHasCategoryModePreference";
import { Rect } from "igniteui-react-core";
import { MarkerSeries } from "./MarkerSeries";
import { DataContext } from "igniteui-react-core";
import { Pool$1 } from "igniteui-react-core";
import { Rectangle } from "igniteui-react-core";
import { ContentControl } from "igniteui-react-core";
import { PropertyMetadata } from "igniteui-react-core";
import { isNaN_, isInfinity, truncate } from "igniteui-react-core";
import { AnnotationLayerView } from "./AnnotationLayerView";
import { Marker } from "./Marker";
import { BrushUtil } from "igniteui-react-core";
import { Color } from "igniteui-react-core";
import { DataTemplatePassInfo } from "igniteui-react-core";
import { DataTemplateRenderInfo } from "igniteui-react-core";
import { DataTemplateMeasureInfo } from "igniteui-react-core";
/**
 * @hidden
 */
var CategoryItemHighlightLayer = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(CategoryItemHighlightLayer, _super);
    function CategoryItemHighlightLayer() {
        var _this = _super.call(this) || this;
        _this.th = false;
        _this.tg = true;
        _this.tk = 10;
        var a = new CategoryItemHighlightLayerFrame();
        var b = new CategoryItemHighlightLayerFrame();
        var c = new CategoryItemHighlightLayerFrame();
        _this.qq = a;
        _this.qp = b;
        _this.qr = c;
        _this.ab = CategoryItemHighlightLayer.$;
        return _this;
    }
    CategoryItemHighlightLayer.prototype.get_dc = function () {
        return true;
    };
    CategoryItemHighlightLayer.prototype.by = function () {
        return new CategoryItemHighlightLayerView(this);
    };
    CategoryItemHighlightLayer.prototype.l4 = function (a) {
        _super.prototype.l4.call(this, a);
        this.tb = a;
    };
    CategoryItemHighlightLayer.prototype.r3 = function (a, b) {
        if (this.tf == null || this.tf == a) {
            if (!this.at.c) {
                this.mn(b);
            }
        }
    };
    CategoryItemHighlightLayer.prototype.qw = function (a) {
        if (!_super.prototype.qw.call(this, a)) {
            return false;
        }
        if (this.tt != null) {
            if (a.dx) {
                var b = a.ju();
                if (!Base.equalsStatic(this.tt, b)) {
                    return false;
                }
            }
            else {
                if (!Base.equalsStatic(this.tt, a.name)) {
                    return false;
                }
            }
        }
        var c = this.ry(a);
        if (!c.c) {
            return false;
        }
        return true;
    };
    CategoryItemHighlightLayer.prototype.r5 = function (a, b) {
        var e_1, _a;
        var _this = this;
        _super.prototype.r5.call(this, a, b);
        var c = a;
        var d = this.tj;
        c.g.clear();
        if (isNaN_(this.s8.x) && isNaN_(this.s8.y)) {
            return;
        }
        if (this.qw(this.tf)) {
            this.tz(this.tf, c, d);
        }
        else {
            try {
                for (var _b = __values(fromEnum(this.ce.series)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var e = _c.value;
                    if (this.qw(e)) {
                        this.tz(e, c, d);
                    }
                    if (e.isStacked) {
                        e.lf(function (f) {
                            if (_this.qw(f)) {
                                _this.tz(f, c, d);
                            }
                            return true;
                        });
                    }
                }
            }
            catch (e_1_1) {
                e_1 = { error: e_1_1 };
            }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return))
                        _a.call(_b);
                }
                finally {
                    if (e_1)
                        throw e_1.error;
                }
            }
        }
    };
    CategoryItemHighlightLayer.prototype.l9 = function (a, b, c, d) {
        _super.prototype.l9.call(this, a, b, c, d);
        switch (b) {
            case CategoryItemHighlightLayer.$$p[4]:
            case CategoryItemHighlightLayer.$$p[5]:
            case CategoryItemHighlightLayer.$$p[2]:
            case CategoryItemHighlightLayer.$$p[3]:
                this.mn(true);
                break;
            case CategoryItemHighlightLayer.$$p[7]:
            case CategoryItemHighlightLayer.$$p[8]:
                this.mn(true);
                break;
            case CategoryItemHighlightLayer.$$p[9]:
                this.th = d;
                this.mn(true);
                break;
            case CategoryItemHighlightLayer.$$p[1]:
                this.mn(true);
                break;
            case CategoryItemHighlightLayer.$$p[0]:
                this.tk = this.tl;
                this.mn(true);
                break;
            case CategoryItemHighlightLayer.$$p[6]:
                this.tg = d;
                this.mn(true);
                break;
        }
    };
    CategoryItemHighlightLayer.prototype.tz = function (a, b, c) {
        if (this.b1 == null || this.b1.bv.isEmpty || this.b1.bu.isEmpty) {
            return;
        }
        if (!a.dj && !a.ds) {
            return;
        }
        var d = a;
        if (d.categoryAxis == null) {
            return;
        }
        var e = this.s8.x;
        e = this.b1.bu.left + this.b1.bu.width * (e - this.b1.bv.left) / this.b1.bv.width;
        var f = this.s8.y;
        f = this.b1.bu.top + this.b1.bu.height * (f - this.b1.bv.top) / this.b1.bv.height;
        var g = this.ti;
        var h = true;
        var i = typeCast(IHasCategoryModePreference_$type, a);
        var j = 0;
        if (i != null) {
            j = i.preferredCategoryMode(d.categoryAxis);
            if (j == 2) {
                h = false;
            }
        }
        var k = true;
        if (!h || this.tc == 2) {
            k = false;
        }
        if (this.tc == 1) {
            k = true;
        }
        var l = this.ry(a);
        if (!l.c) {
            return;
        }
        if (k) {
            var m = a.ps(l.d, this.tj, g);
            if (j != 0 && !d.categoryAxis.cn) {
                var n = m.x;
                if (a.ds) {
                    n -= a.getOffsetValue();
                    n += a.getCategoryWidth() * 0.5;
                    m = { $type: Point_$type, x: n, y: m.y };
                }
                else if (a.dj) {
                    n -= a.getOffsetValue();
                    n += a.getCategoryWidth() * 0.5;
                    m = { $type: Point_$type, x: n, y: m.y };
                }
            }
            if (!isNaN_(m.x) && !isNaN_(m.y)) {
                m = this.px(m);
            }
            this.tx(m, b, a);
        }
        else {
            var o = a.ps(l.d, this.tj, g);
            var p = void 0;
            var q = this.getEffectiveViewport1(this.b1);
            if (a.isVertical) {
                var r = o.y;
                var s = d.categoryAxis;
                var t = this.tk;
                if (j != 0) {
                    t = s.k4(this.b1.bv, this.b1.bu, q);
                }
                if (isNaN_(t) || isInfinity(t)) {
                    return;
                }
                p = new Rect(0, this.p7.left, r - t / 2, this.p7.width, t);
            }
            else {
                var u = o.x;
                var v = d.categoryAxis;
                var w = this.tk;
                if (j != 0) {
                    w = v.k4(this.b1.bv, this.b1.bu, q);
                }
                if (isNaN_(w) || isInfinity(w)) {
                    return;
                }
                p = new Rect(0, u - w / 2, this.p7.top, w, this.p7.height);
            }
            p.intersect(this.b1.bu);
            this.ty(p, b, a);
        }
    };
    CategoryItemHighlightLayer.prototype.tx = function (a, b, c) {
        var d = new ItemHighlightFrameRect();
        d.b = a.x;
        d.e = a.y;
        d.i = this.sy();
        if (this.ud != null) {
            d.i = this.ud;
        }
        d.j = this.sz();
        if (this.ue != null) {
            d.j = this.ue;
        }
        if (d.i == null) {
            if (c.hasMarkers) {
                d.i = this.tb.ci(c.pc());
            }
            else {
                d.i = this.tb.ci(c.o5);
            }
        }
        if (d.j == null) {
            if (c.hasMarkers) {
                d.j = this.tb.ci(c.pd());
            }
            else {
                d.j = this.tb.ci(c.o8);
            }
        }
        d.d = this.fy;
        d.f = Base.getHashCodeStatic(c);
        d.g = this.td(c, a);
        var e = (typeCast(MarkerSeries.$, c) !== null) ? c.q5 : null;
        if (e == null || e == MarkerSeries.q8 || (this.te != 2 && this.te != 0)) {
            var f = MarkerSeries.qm(c, 2);
            if (this.te != 2 && this.te != 0) {
                f = this.te;
            }
            switch (f) {
                case 3:
                case 13:
                    e = this.ce.pv;
                    break;
                case 4:
                    e = this.ce.p4;
                    break;
                case 5:
                    e = this.ce.p1;
                    break;
                case 6:
                    e = this.ce.p2;
                    break;
                case 7:
                    e = this.ce.pw;
                    break;
                case 8:
                    e = this.ce.pz;
                    break;
                case 9:
                    e = this.ce.px;
                    break;
                case 10:
                    e = this.ce.p3;
                    break;
                case 11:
                    e = this.ce.p0;
                    break;
                case 12:
                    e = this.ce.py;
                    break;
            }
        }
        d.h = this.t2 != null ? this.t2 : e;
        if (!isNaN_(d.b) && !isNaN_(d.e)) {
            b.g.addItem(d.f, d);
        }
    };
    CategoryItemHighlightLayer.prototype.td = function (a, b) {
        var c = a.hy(b);
        var d = a.f9(b);
        if (this.tj && d != Math.floor(d)) {
            c = null;
        }
        return ((function () {
            var $ret = new DataContext();
            $ret.series = a;
            $ret.item = c;
            return $ret;
        })());
    };
    CategoryItemHighlightLayer.prototype.ty = function (a, b, c) {
        var d = new ItemHighlightFrameRect();
        d.b = a.left;
        d.e = a.top;
        d.c = a.right;
        d.a = a.bottom;
        d.i = this.sy();
        d.j = this.sz();
        if (d.i == null) {
            if (c != null) {
                d.i = this.tb.cj(c.o5);
            }
        }
        if (d.j == null) {
            if (c != null) {
                d.j = this.tb.cj(c.o8);
            }
        }
        d.d = this.fy;
        d.f = Base.getHashCodeStatic(c);
        if (!a.isEmpty) {
            b.g.addItem(d.f, d);
        }
    };
    CategoryItemHighlightLayer.prototype.r8 = function (a, b) {
        var e_2, _a;
        _super.prototype.r8.call(this, a, b);
        var c = this.tb.b6;
        var d = this.tb.b5;
        var e = 0;
        var f = 0;
        var g = a;
        try {
            for (var _b = __values(fromEnum(g.g.values)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var h = _c.value;
                if (h.h != null) {
                    var i = d.item(f);
                    this.t0(h, i);
                    f++;
                }
                else {
                    var j = c.item(e);
                    this.t1(h, j);
                    e++;
                }
            }
        }
        catch (e_2_1) {
            e_2 = { error: e_2_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_2)
                    throw e_2.error;
            }
        }
        c.count = e;
        d.count = f;
    };
    CategoryItemHighlightLayer.prototype.t0 = function (a, b) {
        if (isNaN_(a.b) || isNaN_(a.e) || isNaN_(a.d) || a.g == null) {
            b._visibility = 1;
            return;
        }
        var c = { $type: Point_$type, x: a.b, y: a.e };
        var d = a.g;
        d.itemBrush = a.i;
        var e = d.series.ps(c, this.cw() || this.th, this.tg);
        if (isNaN_(e.x) || isNaN_(e.y)) {
            b._visibility = 1;
            return;
        }
        this.tb.cc(b, e.x, e.y);
        b.ah = a.h;
        b.content = a.g;
    };
    CategoryItemHighlightLayer.prototype.t1 = function (a, b) {
        if (isNaN_(a.b) || isNaN_(a.e) || isNaN_(a.a) || isNaN_(a.c) || isNaN_(a.d)) {
            b._visibility = 1;
            return;
        }
        this.tb.cd(b, a.b, a.e, a.c - a.b, a.a - a.e);
        b._fill = a.i;
        b._stroke = a.j;
        b.ad = a.d;
        if (this.pi != null) {
            b.ai = this.pi;
        }
        else {
            b.ai = null;
        }
        b.aj = this.pj;
        b.am = this.pl;
        b.al = this.pk;
        b.ak = this.pk;
        b.ac = this.gw;
    };
    CategoryItemHighlightLayer.prototype.ep = function () {
        return true;
    };
    CategoryItemHighlightLayer.$t = markType(CategoryItemHighlightLayer, 'CategoryItemHighlightLayer', AnnotationLayer.$);
    CategoryItemHighlightLayer.$$p = markDep(DependencyProperty, PropertyMetadata, CategoryItemHighlightLayer, 'raisePropertyChanged', ['BandHighlightWidth:tl:t3', [1, 10], 'HighlightType:tc:t4', [CategoryItemHighlightType_$type, enumGetBox(CategoryItemHighlightType_$type, 0)], 'MarkerBrush:ud:t5', [Brush.$, null], 'MarkerOutline:ue:t6', [Brush.$, null], 'MarkerTemplate:t2:t7', [DataTemplate.$, null], 'MarkerType:te:t8', [MarkerType_$type, enumGetBox(MarkerType_$type, 2)], 'SkipUnknownValues:ti:t9', [0, true], 'TargetSeriesName:tt:ua', [2, null], 'TargetSeries:tf:ub', [Series.$, null], 'UseInterpolation:tj:uc', [0, false]]);
    return CategoryItemHighlightLayer;
}(AnnotationLayer));
export { CategoryItemHighlightLayer };
/**
 * @hidden
 */
var CategoryItemHighlightLayerView = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(CategoryItemHighlightLayerView, _super);
    function CategoryItemHighlightLayerView(a) {
        var _this = _super.call(this, a) || this;
        _this.b4 = null;
        _this.b6 = null;
        _this.b5 = null;
        _this.b7 = null;
        _this.b8 = null;
        _this.b4 = a;
        _this.b7 = new List$1(ContentControl.$, 0);
        _this.b8 = new List$1(Rectangle.$, 0);
        return _this;
    }
    CategoryItemHighlightLayerView.prototype.as = function () {
        var _this = this;
        _super.prototype.as.call(this);
        this.b6 = ((function () {
            var $ret = new Pool$1(Rectangle.$);
            $ret.create = runOn(_this, _this.ck);
            $ret.activate = runOn(_this, _this.ce);
            $ret.disactivate = runOn(_this, _this.cg);
            $ret.destroy = runOn(_this, _this.cf);
            return $ret;
        })());
        this.b5 = ((function () {
            var $ret = new Pool$1(ContentControl.$);
            $ret.create = runOn(_this, _this.ch);
            $ret.activate = runOn(_this, _this.b9);
            $ret.disactivate = runOn(_this, _this.cb);
            $ret.destroy = runOn(_this, _this.ca);
            return $ret;
        })());
    };
    CategoryItemHighlightLayerView.prototype.ck = function () {
        var a = new Rectangle();
        a.ab = false;
        this.b8.add(a);
        return a;
    };
    CategoryItemHighlightLayerView.prototype.ce = function (a) {
        a._visibility = 0;
    };
    CategoryItemHighlightLayerView.prototype.cg = function (a) {
        a._visibility = 1;
    };
    CategoryItemHighlightLayerView.prototype.cf = function (a) {
        this.b8.remove(a);
    };
    CategoryItemHighlightLayerView.prototype.ch = function () {
        var a = new Marker();
        this.b7.add(a);
        return a;
    };
    CategoryItemHighlightLayerView.prototype.b9 = function (a) {
        a._visibility = 0;
    };
    CategoryItemHighlightLayerView.prototype.cb = function (a) {
        a._visibility = 1;
    };
    CategoryItemHighlightLayerView.prototype.ca = function (a) {
        this.b7.remove(a);
    };
    CategoryItemHighlightLayerView.prototype.ci = function (a) {
        if (a == null) {
            return a;
        }
        return BrushUtil.l(a, 0.3);
    };
    CategoryItemHighlightLayerView.prototype.cj = function (a) {
        if (a != null) {
            var b = BrushUtil.l(a, 0.3);
            if (b.isGradient) {
                var c = b;
                if (c.gradientStops != null) {
                    for (var d = 0; d < c.gradientStops.length; d++) {
                        var e = c.gradientStops[d];
                        e.color = Color.u(truncate(Math.round((e.color.l) * 0.3)), e.color.o, e.color.n, e.color.m);
                        e.color = e.color;
                    }
                }
            }
            else {
                b.color = Color.u(truncate(Math.round((b.color.l & 255) * 0.3)), b.color.o, b.color.n, b.color.m);
                b.color = b.color;
            }
            return b;
        }
        else {
            return null;
        }
    };
    CategoryItemHighlightLayerView.prototype.cd = function (a, b, c, d, e) {
        a._visibility = 0;
        a.n = b;
        a.o = c;
        a.width = d;
        a.height = e;
    };
    CategoryItemHighlightLayerView.prototype.cc = function (a, b, c) {
        a.n = b;
        a.o = c;
    };
    CategoryItemHighlightLayerView.prototype.bh = function (a, b) {
        _super.prototype.bh.call(this, a, b);
        var c = a;
        var d = c.content;
        if (d != null) {
            if (d.itemBrush != null) {
                d.actualItemBrush = d.itemBrush;
            }
            var e = d.series;
            if (e.hasMarkers) {
                d.outline = e.pd();
            }
            d.thickness = e.f6();
        }
    };
    CategoryItemHighlightLayerView.prototype.a6 = function (a, b) {
        var e_3, _a;
        _super.prototype.a6.call(this, a, b);
        if (a.d && !b) {
            for (var c = 0; c < this.b8.count; c++) {
                var d = this.b8._inner[c];
                if (d._visibility == 0) {
                    a.w(d);
                }
            }
            if (this.b7.count > 0) {
                var e = new DataTemplatePassInfo();
                e.isHitTestRender = b;
                e.context = a.h();
                e.viewportTop = this.bu.top;
                e.viewportLeft = this.bu.left;
                e.viewportWidth = this.bu.width;
                e.viewportHeight = this.bu.height;
                e.passID = "ItemMarkers";
                var f = new DataTemplateRenderInfo();
                f.isHitTestRender = b;
                f.passInfo = e;
                var g = new DataTemplateMeasureInfo();
                g.passInfo = e;
                var h = false;
                var i = a.h();
                g.context = i;
                f.context = i;
                g.renderContext = a;
                f.renderContext = a;
                var j = 0;
                var k = 0;
                var l = new Dictionary$2(DataTemplate.$, DataTemplate.$, 0);
                for (var m = 0; m < this.b7.count; m++) {
                    var n = this.b7._inner[m];
                    if (n == null || n.ah == null) {
                        continue;
                    }
                    var o = n.ah;
                    if (!l.containsKey(o)) {
                        l.addItem(o, o);
                        if (o != null && o.passStarting != null) {
                            o.passStarting(e);
                        }
                    }
                    if (n._visibility == 1) {
                        continue;
                    }
                    this.bg(n, m, b);
                    if (!h) {
                        g.data = n.content;
                        g.width = n.width;
                        g.height = n.height;
                        if (o.measure != null) {
                            g.data = n.content;
                            o.measure(g);
                            h = g.isConstant;
                            if (h) {
                                j = g.width;
                                k = g.height;
                            }
                        }
                        f.availableWidth = g.width;
                        f.availableHeight = g.height;
                    }
                    else {
                        f.availableWidth = j;
                        f.availableHeight = k;
                    }
                    if (!isNaN_(n.width) && !isInfinity(n.width)) {
                        f.availableWidth = n.width;
                    }
                    if (!isNaN_(n.height) && !isInfinity(n.height)) {
                        f.availableHeight = n.height;
                    }
                    a.q(f, n);
                    n.m = f.availableWidth;
                    n.l = f.availableHeight;
                }
                try {
                    for (var _b = __values(fromEnum(l.keys)), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var p = _c.value;
                        if (p != null && p.passCompleted != null) {
                            p.passCompleted(e);
                        }
                    }
                }
                catch (e_3_1) {
                    e_3 = { error: e_3_1 };
                }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return))
                            _a.call(_b);
                    }
                    finally {
                        if (e_3)
                            throw e_3.error;
                    }
                }
            }
        }
    };
    CategoryItemHighlightLayerView.prototype.al = function (a) {
        _super.prototype.al.call(this, a);
        for (var b = 0; b < this.b8.count; b++) {
            this.e.a9.exportRectangleData(a, this.b8._inner[b], "catItemRect", ["Main", "CategoryItem"]);
        }
        for (var c = 0; c < this.b7.count; c++) {
            this.e.a9.exportMarkerVisualDataFromMarker(this.e, a, this.b7._inner[c]);
        }
    };
    CategoryItemHighlightLayerView.$t = markType(CategoryItemHighlightLayerView, 'CategoryItemHighlightLayerView', AnnotationLayerView.$);
    return CategoryItemHighlightLayerView;
}(AnnotationLayerView));
export { CategoryItemHighlightLayerView };
